module.exports = __webpack_public_path__ + "img/intro-3.c4a48cdf.png";